import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 14.175H5c-2.8 0-5 2.151-5 4.888v1.955c0 .587.4.978 1 .978s1-.391 1-.978v-1.955c0-1.662 1.3-2.932 3-2.932h8c1.7 0 3 1.27 3 2.932v1.955c0 .587.4.978 1 .978s1-.391 1-.978v-1.955c0-2.737-2.2-4.888-5-4.888M9 12.22c2.8 0 5-2.15 5-4.888s-2.2-4.888-5-4.888-5 2.151-5 4.888 2.2 4.888 5 4.888M9 4.4c1.7 0 3 1.27 3 2.932s-1.3 2.933-3 2.933-3-1.27-3-2.933S7.3 4.4 9 4.4m11.2 9.97c-.5-.097-1.1.196-1.2.685s.2 1.076.7 1.173c1.3.294 2.2 1.467 2.2 2.835v1.955c0 .587.4.978 1 .978s1-.391 1-.978v-1.955c.1-2.248-1.4-4.203-3.7-4.692Zm-4-11.73c-.5-.196-1 .098-1.2.684-.1.489.2 1.076.7 1.173 1.6.391 2.6 1.955 2.2 3.617-.3 1.076-1.1 1.858-2.2 2.151-.5.098-.9.684-.7 1.173.1.489.5.782 1 .782h.2c1.8-.489 3.2-1.76 3.6-3.52.7-2.736-.9-5.474-3.6-6.06"
    }, null, -1)
  ]))]))
}
export default { render: render }